//@ts-check
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import { makeStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import { Page } from 'ecrion-components';
import { useAuth } from '../context/AuthContext';
import { useUser } from '../context/UserContext';

const useStyles = makeStyles((theme) => ({
  toolbar: {
    backgroundColor: theme.common.Page.NavBar.style.backgroundColor,
    minHeight: theme.common.Page.NavBar.style.height,
    maxHeight: theme.common.Page.NavBar.style.height,
    boxShadow: theme.common.Page.NavBar.style.boxShadow
  },
  logo: {
    height: 24,
    width: 24,
    verticalAlign: 'middle',
    borderRadius: '50%',
  },
  userBox: {
    color: '#000000',
    height: theme.common.Page.NavBar.style.height,
    '&:hover': {
      backgroundColor:theme.common.Page.NavBar.style.hoverBackground
    },
    '&:focus, &:active':{
      backgroundColor:theme.common.Page.NavBar.style.activeBackground
    }    
  },
  userBoxText: {
    color: '#000000',
  },
}));

const NavBar = () => {
  const { logout } = useAuth();
  const user = useUser();
  const classes = useStyles();
  let history = useHistory();
  const environment = user.Environment;
  const encodedEnvironment = encodeURIComponent(environment);

  const displayName = user.DisplayName;

  const drawerEntries = [
    [
      {
        label: 'My Account',
        props: {
          to: `/${encodedEnvironment}/profile`,
        },
      },
    ],
    [
      {
        label: 'Logout',
        type: 'button',
        props: {
          onClick: logout,
        },
      },
    ],
  ];

  return (
    <Toolbar className={`${classes.toolbar} navbar`} disableGutters>
      <Grid container alignItems="center">
        <Grid item xs />

        <Grid item>
          <Button
            onClick={() => history.push(`/${encodedEnvironment}/`)}
            className={`${classes.userBox} environment-button`}
          >
            <Grid container alignItems="center" justify='center' spacing={1}>
              {user.EnvironmentLogoUrl && (
                <Grid item>
                  <img
                    className={classes.logo}
                    src={
                      process.env.REACT_APP_WEBSITE_URL +
                      user.EnvironmentLogoUrl
                    }
                    alt="Environment Logo"
                  />
                </Grid>
              )}
              <Grid item>
                <Typography
                  variant="inherit"
                  className={classes.userBoxText}
                  noWrap
                >
                  {environment}
                </Typography>
              </Grid>
            </Grid>
          </Button>
        </Grid>

        <Grid item xs>
          <Grid container justify="flex-end">
            <Grid item>
              <Page.NavBar.UserComponent
                className="user-info-component"
                userDisplayName={displayName}
                drawerEntries={drawerEntries}
                linkComponent={Link}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Toolbar>
  );
};

export default NavBar;
